import { type MouseEventHandler } from 'react'
import { icons } from '@opallabs/constellation'
import { Size } from '@opallabs/gem'
import {
  type WithMultipleStyleOverrides,
  type WithTheme,
} from '../../gem/commonProps'

type HypernovaGlyph = Readonly<{
  glyph: keyof typeof icons.hypernova
  useHypernova: true
}>
type GemGlyph = Readonly<{
  glyph: keyof typeof icons.gem
  useHypernova?: never | false
}>
type Glyph = HypernovaGlyph | GemGlyph

export type IconProps = Readonly<
  WithMultipleStyleOverrides<'container' | 'icon'> &
    WithTheme &
    Glyph & {
      ariaHidden?: boolean
      ariaLabel?: Element['ariaLabel']
      ariaMode?: 'visible' | 'presentational' | 'hidden'
      className?: string
      color?: 'none' | 'currentColor' | string
      /** @note Prefer `size`, which automatically applies to both dimensions */
      height?: number
      htmlId?: string
      /** @deprecated If you need a clickable Icon component, use a Button w/ an icon inside. */
      onClick?: MouseEventHandler<HTMLDivElement>
      role?: string
      size?: number
      tabIndex?: number
      /** @note Prefer `size`, which automatically applies to both dimensions */
      width?: number
    }
>

/** For use in Storybook, which can’t extract destructured defaults within `forwardRef()` */
export const propDefaults = {
  ariaMode: 'visible',
  color: 'currentColor',
  height: Size.Icon,
  role: 'img',
  useHypernova: false,
  width: Size.Icon,
} as const satisfies Omit<IconProps, 'glyph'>
